<template>
  <div class="animated fadeIn remitos-facturacion">
    <b-row>
      <b-col xl="12">
        <b-form>
          <!-- <b-card > -->
          <b-card header="Remitos del Transporte">
            <b-row>
              <b-col xl="12">
                <b-form-group
                  label="Transporte"
                  label-for="transporte"
                  :label-cols="labelCols"
                  horizontal>
                  <b-input-group>
                    <b-input-group-append 
                        class="filter-search-icons" 
                        @click="seleccionarTransporte">
                      <b-input-group-text>
                        <i class="fa fa-search"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                    <b-form-input 
                      id="transporte"
                      :value="transporteNombre"
                      readonly
                      type="text"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          <!-- </b-card> -->

          <!-- <b-card header="Remitos del Transporte"> -->
            <b-row>
              <b-col xl="12">
                <b-table 
                    small 
                    responsive="sm"
                    class="registro-ordenes" 
                    :busy="tableBusy"
                    :items="remitos" 
                    :fields="fields"
                    :current-page="paginaActual"
                    :per-page="registrosPorPagina">
                  <div slot="table-busy" class="text-center">
                    <b-spinner class="table-spinner" label="Spinning" />
                  </div>              
                  <template v-slot:cell(fechaComprobante)="data">
                    {{ data.item.fechaComprobante | fecha }}
                  </template>
                  <template v-slot:cell(importeActualizado)="data">
                      <input type="number"
                        @focus="$event.target.select()"
                        v-model="data.item.importeActualizado"
                        step="0.01"/>
                  </template> 

                  <!-- <template v-slot:cell(actualizarImporte)="data">
                      <i @click.prevent="actualizarImporte(data.item)" 
                        v-if="data.item.importe != data.item.importeActualizado"
                        class="fa fa-save actualizar-importe"></i>
                  </template> 

                  <template v-slot:cell(resetearImporte)="data">
                      <i @click.prevent="resetearImporte(data.item)" 
                        v-if="data.item.importe != data.item.importeActualizado"
                        class="fa fa-close resetear-importe"></i>
                  </template>  -->

                  <template v-slot:cell(opciones)="data">
                    <template v-if="data.item.importe != data.item.importeActualizado">
                      <div class="opciones-iconos">
                        <i @click.prevent="actualizarImporte(data.item)" 
                          class="fa fa-save actualizar-importe"></i>
  
                        <i @click.prevent="resetearImporte(data.item)" 
                          class="fa fa-close resetear-importe"></i>
                      </div>
                    </template>

                    <template v-if="data.item.importe == data.item.importeActualizado">
                      <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                        <template slot="button-content">
                          <i class="fa fa-ellipsis-v"></i>
                        </template>
  
                        <b-dropdown-item 
                            @click.stop="consultarRemito(data.item)">
                          <i class="fa fa-info"></i>Consultar Datos del Remito</b-dropdown-item>
                        <!-- <b-dropdown-item 
                            :disabled="data.item.ordenTrabajoId == 0"
                            @click.stop="editarOrdenTrabajo(data.item)">
                          <i class="fa fa-edit"></i>Editar Orden de Trabajo</b-dropdown-item> -->
                      </b-dropdown>
                    </template>
                  </template>

                  <template v-slot:cell(detailShowing)="row">
                    <b-btn class="detailShowing" 
                        size="sm"
                        v-if="row.item.presupuestoInternoId != 0" 
                        @click.stop="row.item._showDetails = !row.item._showDetails">
                      {{ row.item._showDetails ? '-' : '+' }}
                    </b-btn>            
                  </template>

                  <template v-slot:row-details="row">
                    <b-row>
                      <b-col xl="12">
                        <b-table 
                            small 
                            responsive="sm"
                            class="registro-ordenes remito-datos" 
                            :busy="tableBusy"
                            :items="row.item.presupuestoInterno" 
                            :fields="fieldsPresupuestoInterno">
                        </b-table>
                      </b-col>
                    </b-row>
                  </template>
                </b-table>
                <nav>
                  <b-pagination size="sm" 
                    :total-rows="totalRegistros" 
                    :per-page="registrosPorPagina" 
                    v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
                </nav>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="searchProveedorModal" 
        title="Seleccionar Transporte"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-proveedor
        :transportes="true"
        @proveedorSeleccionado="transporteSeleccionado">
      </app-search-proveedor>  
    </b-modal>

    <b-modal ref="ordenTrabajoModal" 
        title="Orden de Trabajo"
        modal-class="modalABM  modalOrdenTrabajoProduccion"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-orden-trabajo
        :modal="true"
        :ordenTrabajoId="ordenTrabajoId">
      </app-orden-trabajo>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchProveedor from '../proveedores/SearchList.vue'
import OrdenTrabajo from '../ordenestrabajos/Produccion.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'remitosFacturacion/getField',
  mutationType: 'remitosFacturacion/updateField',
});

export default {
  name: 'ActualizacionImportes',
  components: {
    appSearchProveedor: SearchProveedor,
    appOrdenTrabajo: OrdenTrabajo,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      fields: [
        {
            key: 'detailShowing',
            label: '',
            class: 'text-center'
        },
        {
          key: 'fechaComprobante',
          label: 'Fecha',
          sortable: true
        },
        { 
          key: 'comprobante',
          sortable: true
        },
        { 
          key: 'destino',
        },
        { 
          key: 'usuario',
        },
        // { 
        //   key: 'presupuestoInterno',
        // },
        // { 
        //   key: 'ordenTrabajo',
        //   label: 'Orden'
        // },
        // { 
        //   key: 'subtrabajo',
        // },
        { 
          key: 'importeActualizado',
          label: 'Importe',
          class: "text-right" 
        },

        // {
        //   key: 'actualizarImporte',
        //   label: '',
        //   class: 'text-center'
        // },
        // {
        //   key: 'resetearImporte',
        //   label: '',
        //   class: 'text-center'
        // },

        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],
      
      fieldsPresupuestoInterno: [
        { 
          key: 'presupuestoInterno',
        },
        { 
          key: 'ordenTrabajo',
          label: 'Orden'
        },
        { 
          key: 'subtrabajo',
        },
      ],

      tableBusy: false,
      labelCols: 1,
      ordenTrabajoId: 0,
      paginaActual: 1,
      registrosPorPagina: 10,
      totalRegistros: 0,
      totalPaginas: 0,
    }
  },
  computed: {
    ...mapFields([
      'remitos',
      'transporte',
      'transporteNombre',
    ]),
  },
  created() {
    this.tableBusy = true;
    this.$store.dispatch('remitosFacturacion/inicializar')
      .then(() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    seleccionarTransporte() {
      this.$refs.searchProveedorModal.show()
    },
    transporteSeleccionado(proveedor) {
      this.$refs.searchProveedorModal.hide();
      
      this.tableBusy = true;
      this.$store.dispatch('remitosFacturacion/setTransporte', proveedor)
        .then (() => {
          this.tableBusy = false;
          this.totalRegistros = this.remitos.length;
        })
        .catch(error => this.showErrorMsj(error));
    },

    actualizarImporte(item) {
      this.showSpinner();
      this.$store.dispatch('remitosFacturacion/actualizarImporte', item.remitoId)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    resetearImporte(item) {
      item.importeActualizado = item.importe;
    },
    editarOrdenTrabajo(item) {
      this.ordenTrabajoId = item.ordenTrabajoId;
      this.$refs.ordenTrabajoModal.show();
    },
    consultarRemito(item) {
      this.$router.push({ name: 'RemitoData', 
                            params: { id: item.remitoId }});
    }
  },
  validations: {
  },  
  watch: {
  },
}
</script>

<style>
.remitos-facturacion table {
  margin-top: 20px;
}
.remitos-facturacion table thead tr th {
  border-top: none;
}
.remitos-facturacion table td {
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
  vertical-align: middle;
}
.remitos-facturacion table td[aria-colindex="1"] {
  width: 3%;
}
.remitos-facturacion table td[aria-colindex="2"] {
  width: 12%;
}
.remitos-facturacion table td[aria-colindex="3"] {
  width: Calc(20% - 30px);
  width: Calc(20% - 10px);
}
.remitos-facturacion table td[aria-colindex="4"] {
  width: Calc(30% - 40px);
  width: Calc(30% - 20px);
}
.remitos-facturacion table td[aria-colindex="5"] {
  width: Calc(20% - 35px);
  width: Calc(20% - 20px);
}
.remitos-facturacion table td[aria-colindex="6"] {
  width: 15%;
}
.remitos-facturacion table td[aria-colindex="7"] {
  width: 50px;
}

/*
.remitos-facturacion table td[aria-colindex="7"],
.remitos-facturacion table td[aria-colindex="8"] {
  width: 25px;
}
.remitos-facturacion table td[aria-colindex="9"] {
  width: 50px;
}
*/

.remitos-facturacion .remito-datos table {
  width: 90%;
  /* margin-left: 15px;
   */
  margin-left: 15px;
  margin-bottom: 20px;
  margin-top: 5px;
}
.remitos-facturacion .remito-datos table thead tr th,
.remitos-facturacion .remito-datos table tbody tr td {
  border-top: none;
  border-bottom: none;
}
.remitos-facturacion .remito-datos table td[aria-colindex="1"] {
  width: 30%;
}
.remitos-facturacion .remito-datos table td[aria-colindex="2"],
.remitos-facturacion .remito-datos table td[aria-colindex="3"] {
  width: 30%;
}

.remitos-facturacion .opciones-iconos {
  display: inline-block;
}

.remitos-facturacion i.actualizar-importe {
  color: rgba(32,168,216, 0.5);
  cursor: pointer;
  font-size: 16px;
}
.remitos-facturacion i.actualizar-importe:hover {
  color: rgba(32,168,216, 1);
}
.remitos-facturacion i.resetear-importe {
  color: rgba(248,108,107, 0.5);
  cursor: pointer;
  font-size: 16px;
  margin-left: 10px;
}
.remitos-facturacion i.resetear-importe:hover {
  color: rgba(248,108,107, 1);
}

</style>
